import React from 'react';
import { Button, DialogDescription, DialogFooter } from '@ohif/ui-next';

const COPY = {
  completed: {
    title: 'Report Generated',
    description:
      'Report has been generated for this study. The page needs to be refreshed to show the results.',
  },
  failed: {
    title: 'Report Generation Failed',
    description:
      'Report generation has failed for this study. Please try again later or contact support if the problem persists.',
  },
};

export type DiagnosisCompleteVariant = keyof typeof COPY;

interface DiagnosisCompleteDialogProps {
  variant: DiagnosisCompleteVariant;
  hide?: () => void;
}

export function DiagnosisCompleteDialog({ variant, hide }: DiagnosisCompleteDialogProps) {
  const { description } = COPY[variant];

  return (
    <>
      <DialogDescription className="text-white">{description}</DialogDescription>

      <DialogFooter>
        {variant === 'completed' ? (
          <>
            <Button
              variant="ghost"
              className="hover:text-foreground/60 hover:bg-transparent"
              dataCY="sycai-refresh-later"
              onClick={() => hide?.()}
            >
              Refresh Later
            </Button>
            <Button
              variant="default"
              className="text-white"
              dataCY="sycai-refresh-now"
              onClick={() => {
                hide?.();
                window.location.reload();
              }}
            >
              Refresh Now
            </Button>
          </>
        ) : (
          <Button
            variant="default"
            className="text-white"
            dataCY="sycai-diagnosis-failed-cancel"
            onClick={() => hide?.()}
          >
            Cancel
          </Button>
        )}
      </DialogFooter>
    </>
  );
}

type DiagnosisCompleteModalOptions = {
  title: string;
  content: typeof DiagnosisCompleteDialog;
  contentProps: { variant: DiagnosisCompleteVariant };
  shouldCloseOnEsc: boolean;
  shouldCloseOnOverlayClick: boolean;
};

export function showDiagnosisCompleteDialog(
  uiModalService: AppTypes.UIModalService,
  variant: DiagnosisCompleteVariant
): void {
  const options: DiagnosisCompleteModalOptions = {
    title: COPY[variant].title,
    content: DiagnosisCompleteDialog,
    contentProps: { variant },
    shouldCloseOnEsc: false,
    shouldCloseOnOverlayClick: false,
  };

  uiModalService.show(options as unknown as Parameters<AppTypes.UIModalService['show']>[0]);
}
